import { render, staticRenderFns } from "./FormBtn.vue?vue&type=template&id=26c7e478&functional=true"
import script from "./FormBtn.vue?vue&type=script&lang=js"
export * from "./FormBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/serbanhoratiutudor/Projects/genie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26c7e478')) {
      api.createRecord('26c7e478', component.options)
    } else {
      api.rerender('26c7e478', component.options)
    }
    module.hot.accept("./FormBtn.vue?vue&type=template&id=26c7e478&functional=true", function () {
      api.rerender('26c7e478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/core/FormBtn.vue"
export default component.exports